import React, { useEffect, useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { useFilters } from "@/context/FilterContext";

// Renders a brand chooser for create/edit forms based on the user's role & scope.
export function BrandSelectField({ value, onChange, disabled }) {
  const { user, isCorporate } = useAuth();
  const { nonCorpBrands, brands } = useFilters();

  const options = useMemo(() => {
    if (isCorporate) return nonCorpBrands;
    const allowed = user?.allowed_brand_ids || [];
    return brands.filter((b) => allowed.includes(b.id));
  }, [isCorporate, nonCorpBrands, brands, user]);

  // Auto-select when only one option
  useEffect(() => {
    if (!value && options.length === 1) onChange(options[0].id);
  }, [options, value, onChange]);

  if (options.length <= 1) {
    const only = options[0];
    return (
      <div className="space-y-1.5">
        <Label>Brand</Label>
        <div className="flex h-10 items-center rounded-[10px] border border-[var(--pb-border)] bg-[rgba(24,52,74,0.03)] px-3 text-sm text-[#18344A]">
          {only ? only.name : "No brand assigned"}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <Label>Brand</Label>
      <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid="form-brand-select">
          <SelectValue placeholder="Select a brand" />
        </SelectTrigger>
        <SelectContent>
          {options.map((b) => (
            <SelectItem key={b.id} value={b.id}>
              {b.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
